module.exports = __webpack_public_path__ + "static/media/suir-engineering-ltd.a59aa16c.png";